(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/match-view-mobile.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/match-view-mobile.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.MatchViewMobile = Backbone.Model.extend({
    timeout: null,
    timeoutTimer: 0,

    initialize: function() {
      this.listenTo(
        svs.tipset.collections.matchlist,
        'currentMatchChanged',
        this.update
      );
    },

    update: function() {
      var self = this;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function() {
        var url = svs.tipset.collections.matchlist
          .getCurrentMatch()
          .get('matchLink');
        if (url.indexOf('?') === -1) {
          url += location.search;
        }
        svs.obj.router.navigate(url, {
          trigger: false,
          replace: true
        });

        self.trigger('changeMatch');

        self.timeoutTimer = 0;
      }, this.timeoutTimer);

      this.timeoutTimer = 500;
    }
  });
})(Backbone, _, svs);

 })(window);